export const dot = (color = '#ff6600') => ({
    alignItems: 'center',
    display: 'flex',

    ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
    },
});

export const colourStyles = {
    control: styles => ({
        ...styles,
        height: 33,
        minHeight: 33,
        backgroundColor: 'white',
        ':focus': {
            ...styles[':focus'],
            backgroundColor: "#f8f4de",
            borderColor: '#ff6600'
        },
        ':hover': {
            ...styles[':hover'],
            backgroundColor: "#f8f4de",
            borderColor: '#ff6600'
        },
        ':active': {
            ...styles[':active'],
            backgroundColor: "#f8f4de",
            borderColor: '#ff6600'
        }
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const mainColor = "#ff6600"
        const soft_orange = "#ff944d";
        return {
            ...styles,
            backgroundColor: isSelected ?
                soft_orange
                : isFocused ?
                    mainColor
                    : null,
            color: isSelected || isFocused ?
                "white"
                : "black",
            ':active': {
                ...styles[':active'],
                backgroundColor: mainColor
            },
        };
    },
    input: styles => ({ ...styles }),
    placeholder: styles => ({ ...styles }),
    singleValue: (styles, { data }) => ({ ...styles }),
};